import React, { useState } from "react";
// import i18n from "i18n";
import ProductAddedItem from "../ProductAddedItem";
import Pagination from "../../../../atoms/Pagination";
import styles from "./ProductAddedList.module.scss";
import i18n from "i18n";


export const ProductAddedList = ({
  products,
  total,
  handleEdit,
  handleDelete,
  changePage,
  pagination,
  subtitle = true,
  title = i18n.t("requested.products"),
  trashIcon
}) => {
  const [toggleOpen, setToggleOpen] = useState(false);
  return (
    <div className={styles["product-added-list-wrapper"]}>
      <div
        className={styles[`product-added-list-title`]}
        onClick={() => setToggleOpen(!toggleOpen)}
      >
        <div className={styles[`product-added-list-title-wrapper`]}>
          {title} ({total})
        </div>
      </div>

      {
        <div className={styles["product-added-list-products"]}>
          {products.map(product => {
            return (
              <div key={product.id}>
                <ProductAddedItem
                  subtitle={subtitle}
                  product={product}
                  units={product.units}
                  stock={product.stock}
                  key={product.code}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  trashIcon={trashIcon}
                />
              </div>
            );
          })}
          <div className={styles["product-added-list-pagination"]}>
            <Pagination
              pageQuantity={pagination.pageQuantity}
              currentPage={pagination.currentPage}
              pageChangeHandler={changePage}
            />
          </div>
        </div>
      }
    </div>
  );
};

export default ProductAddedList;
